import { useStyles } from '@team-griffin/stylr';
import { gu2px, useTheme, Colorway, cssTheme } from '@uds/theme-utils';
import { smallprint } from '@ux/type-size';
import cssSides, { Side } from '@team-griffin/css-sides';
import { getBodyColor } from 'presentation/utils/colorway';
import { useBreakpoints } from '@ux/responsive';
import { css, cx } from 'linaria';

const body = {
  default: css`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
  `,
  endorsed: {
    grey: css`
      border-bottom-color: ${cssTheme.palette.grey02};
    `,
    primary: css`
      border-bottom-color: ${cssTheme.palette.primary};
    `,
  },
};
const root = {
  default: css`
    background: transparent;
    flex: 1;
    flex-basis: auto;
  `,
  featured: css`
    margin-top: ${cssTheme.gu4};
  `,
  endorsed: css`
    margin-top: 0;
  `,
};
export const getClassNames = ({
  isEndorsed,
  hasFeaturedProduct,
  colorway,
}: {
  isEndorsed: boolean;
  hasFeaturedProduct?: boolean;
  colorway: Colorway;
}) => {
  const endorsedColorway =
    [Colorway.PRIMARY, Colorway.PRIMARY_GRADIENT, Colorway.HIGHLIGHT].indexOf(colorway) > -1 ? 'grey' : 'primary';
  return {
    root: cx(root.default, hasFeaturedProduct && root.featured, isEndorsed && root.endorsed),
    body: cx(body.default, isEndorsed && body.endorsed[endorsedColorway]),
  };
};

export default ({ colorway }: { colorway: Colorway }) => {
  const { isMinLg } = useBreakpoints();
  const {
    theme,
    theme: { spacing },
  } = useTheme();

  return useStyles(
    {
      default: {
        legalText: {
          ...smallprint(),
          ...cssSides('margin', Side.X, gu2px(3, spacing)),
          marginTop: gu2px(1, spacing),
          color: getBodyColor(theme, colorway),
          opacity: 0.9,
        },
      },
      isMinLg: {
        legalText: {
          ...cssSides('margin', Side.X, gu2px(4, spacing)),
        },
      },
    },
    [{ isMinLg }],
  );
};
